import script from "./PlotDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PlotDetailPanel.vue?vue&type=script&setup=true&lang=js"

import "./PlotDetailPanel.vue?vue&type=style&index=0&id=cba20210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cba20210"]])

export default __exports__